import { render, staticRenderFns } from "./participation_pt.vue?vue&type=template&id=0a1029af&scoped=true&"
import script from "./participation_pt.vue?vue&type=script&lang=js&"
export * from "./participation_pt.vue?vue&type=script&lang=js&"
import style0 from "./participation_pt.vue?vue&type=style&index=0&id=0a1029af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1029af",
  null
  
)

export default component.exports